import { useEffect } from 'react';
import scrollToElement from '../browserUtils/scrollToElement';
import { getScreenSize } from '../common';
import { Breakpoints } from '../constants';
const useScrollTo = ({ shouldScroll, ref, delay, topOffset }) => {
    const MOBILE_HEADER_HEIGHT = 72;
    const HEADER_OFFSET = getScreenSize() === Breakpoints.LARGE ? MOBILE_HEADER_HEIGHT : 0;
    useEffect(() => {
        if (ref && shouldScroll) {
            scrollToElement({
                elem: ref.current,
                delay: delay || 0,
                topOffset: typeof topOffset !== 'undefined' ? topOffset : HEADER_OFFSET,
            });
        }
    }, [shouldScroll]);
};
export default useScrollTo;
//# sourceMappingURL=useScrollTo.js.map